/**
 * 自定义 Cookie 操作模块
 */

const Cookie = {
  /**
   * 获取 cookie 值
   * @param {string} name - cookie 名称
   * @returns {string|null}
   */
  get(name) {
    if (!name) return null
    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    const arr = document.cookie.match(reg)
    if (arr) {
      return decodeURIComponent(arr[2])
    }
    return null
  },

  /**
   * 设置 cookie
   * @param {string} name - cookie 名称
   * @param {string} value - cookie 值
   * @param {number} days - 过期天数（可选，默认会话结束）
   * @param {string} path - 路径（可选）
   */
  set(name, value, days, path = '/') {
    if (!name) return
    const expires = days
      ? '; expires=' + new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
      : ''
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=' + path
  },

  /**
   * 删除 cookie
   * @param {string} name - cookie 名称
   * @param {string} path - 路径（可选）
   */
  remove(name, path = '/') {
    if (!name) return
    this.set(name, '', -1, path)
  }
}

export default Cookie



// WEBPACK FOOTER //
// ./src/utils/cookie.js